import { useEffect } from 'react';
import initialGTM from '../../../../../utils/initialGTM';
import { useRootSelector } from '../../../../../store/hooks';
import {
  selectPricingProductsForGTM,
  selectSitePricingProductsMeta,
} from '../../../store/features/products';
import { useDivisionGTM } from '../useDivisionGTM';

const GTM = initialGTM.gtm;

export const useSelectPackageGTM = () => {
  const productsForGTM = useRootSelector(selectPricingProductsForGTM);
  const { divisionId, divisionInfrontBusinessUnit, divisionName } =
    useRootSelector(selectSitePricingProductsMeta);
  const shouldPushDataToGTM = productsForGTM.length > 0;

  useDivisionGTM({
    divisionId,
    divisionInfrontBusinessUnit,
    divisionName,
    disablePushDataToGTM: !shouldPushDataToGTM,
  });

  useEffect(() => {
    if (shouldPushDataToGTM) {
      GTM.dataLayer({
        dataLayer: {
          event: 'ga-event',
          ga: {
            event: 'Product Details',
            ecommerce: {
              detail: {
                products: productsForGTM,
              },
            },
          },
        },
      });
    }
    // eslint-disable-next-line
  }, []);
};
